import React from "react";
import PropTypes from "prop-types";
import TextBlock from "./TextBlock";

/**
 * HeadingBlock: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Content block for a text heading based on
 * the TextBlock
 *
 * @param {*} props
 */
const HeadingBlock = props =>
  props.isReadOnlyMode ? (
    <h2>
      <TextBlock {...props} />
    </h2>
  ) : (
    <TextBlock {...props} />
  );

HeadingBlock.propTypes = {
  isReadOnlyMode: PropTypes.bool.isRequired
};

export default HeadingBlock;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/text/HeadingBlock.js